import React from 'react';

const reviews = [
  {
    id: 1,
    name: "Priyanka Surandase",
    location: "New Jersey, USA",
    role: "Nauvari Client",
    review: "The customized Shahi Mastani Saree exceeded my expectations. The fabric quality, elegant draping, and attention to detail made me feel confident and beautiful throughout the wedding ceremony. I highly recommend Tuljai Boutique for bridal Nauvari stitching.",
    sareeTag: "Shahi Mastani Nauvari"
  },
  {
    id: 2,
    name: "Pooja Dhaskat",
    location: "Wardha, Maharashtra",
    role: "Blouse Client",
    review: "The Paithani blouse designed by Tuljai Boutique was absolutely stunning. The intricate embroidery, perfect fitting, and elegant finishing beautifully complemented my saree. I received so many compliments at my cousin's wedding.",
    sareeTag: "Paithani Blouse Artistry"
  },
  {
    id: 3,
    name: "Meenakshi Kulkarni",
    location: "Amravati, Maharashtra",
    role: "Hand Crafted Lacha Client",
    review: "I wanted a traditional lacha with a modern touch for my sister's wedding, and Tuljai Boutique created exactly what I had imagined. The custom fabric, elegant flare, and flawless stitching made my outfit truly unique.",
    sareeTag: "Heritage Restoration"
  }
];

const ReviewsSection = () => {
  return (
    <section className="bg-[#F9F6F0] py-24 px-6 md:px-12 lg:px-20 border-t border-[#5c1d24]/10">
      <div className="max-w-7xl mx-auto">
        
        {/* Section Title & Traditional Quote Banner */}
        <div className="text-center max-w-2xl mx-auto mb-20 space-y-3">
          <span className="text-xs font-semibold uppercase tracking-widest text-[#5c1d24] bg-[#5c1d24]/5 px-4 py-1.5 rounded-full">
            कृतज्ञता • Word of Mouth
          </span>
          <h2 className="font-serif text-3xl md:text-5xl text-neutral-900 tracking-wide font-light pt-2">
            Voices of Tradition
          </h2>
          <div className="w-16 h-[1px] bg-[#5c1d24] mx-auto my-4"></div>
          <p className="font-serif text-sm italic text-amber-800 tracking-wide">
            "ग्राहकांचे समाधान हीच आमची परंपरा" (Customer satisfaction is our ultimate tradition)
          </p>
        </div>

        {/* Modern Elegant Reviews Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {reviews.map((item) => (
            <div 
              key={item.id}
              className="relative bg-white border border-neutral-200/60 p-8 pt-12 rounded-sm shadow-xs transition-all duration-300 hover:shadow-md flex flex-col justify-between"
            >
              {/* Decorative Marathi Royal Arch Accent on Top Border */}
              <div className="absolute top-0 left-1/2 -translate-x-1/2 w-24 h-[3px] bg-gradient-to-r from-transparent via-[#5c1d24] to-transparent"></div>

              {/* Gold Quote Mark & Stars */}
              <div className="space-y-2">
                <div className="flex items-center space-x-1 text-amber-500 text-xs tracking-widest">
                  <span>★</span><span>★</span><span>★</span><span>★</span><span>★</span>
                </div>
                
                {/* Main Review text */}
                <p className="text-sm text-neutral-600 leading-relaxed font-light italic pt-2">
                  "{item.review}"
                </p>
              </div>

              {/* Reviewer Footnote Details */}
              <div className="pt-6 mt-6 border-t border-neutral-100 space-y-2">
                <div className="flex items-center justify-between">
                  <div>
                    <h4 className="font-serif text-md font-medium text-neutral-900 tracking-wide">
                      {item.name}
                    </h4>
                    <p className="text-[11px] text-neutral-400 font-light tracking-wide">
                      {item.role} • {item.location}
                    </p>
                  </div>
                </div>

                {/* Subtle Luxury Saree Capsule Tag */}
                <div className="pt-2">
                  <span className="inline-block text-[10px] uppercase font-semibold tracking-widest text-[#5c1d24] bg-[#5c1d24]/5 px-2 py-0.5 rounded-sm">
                    {item.sareeTag}
                  </span>
                </div>
              </div>

            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default ReviewsSection;